import React from 'react';
import WarehouseOpsPage from './WarehouseOpsPage';
export default function StockAdjustment() {
  return <WarehouseOpsPage mode="adjust" title="Stock Adjustment" subtitle="Correct verified inventory discrepancies" />;
}
